<template>
  <div :class="`applicator-card ${hasShowcaseProjects ? 'has-projects' : null} ${label.class ? label.class : ''} ${$root.showExpandedResults !== true && $root.expandedResults === true ? 'hidden' : ''}`" :aria-disabled="$root.loadingApplicator !== false">

    <div v-if="$root.loadingApplicator === applicator.user_id" class="applicator-card-loading">
      <spinner color="#F69422" />
    </div>

    <button v-if="closeButton" class="applicator-card-close" @click.prevent="CloseApplicator">×</button>

    <div class="applicator-card-content">

      <div v-if="hasShowcaseProjects" class="applicator-card-showcase">
        <figure class="applicator-card-showcase-slider">
          <div class="applicator-card-showcase-projects" :data-active="activeShowcaseProject">
            <img v-for="n in (applicator.top_project_picture_urls.length)" :src="ImageResize(applicator.top_project_picture_urls[n-1], 300)" :alt="`Featured Project`" />
          </div>
        </figure>
        <div v-if="applicator.top_project_picture_urls !== null && applicator.top_project_picture_urls.length > 1" class="applicator-card-showcase-nav">
          <button v-for="n in (applicator.top_project_picture_urls.length)" :idx="n" :aria-selected="activeShowcaseProject === applicator.top_project_picture_urls[n-1]"  @click.prevent="SetActiveShowcaseProject(n-1)">
            <img :src="ImageResize(applicator.top_project_picture_urls[n-1], 72)" :alt="`Featured Project Thumbnail`" />
          </button>
        </div>
      </div>

      <figure v-else-if="hasBannerImage" class="applicator-card-banner">
        <img :src="applicator.banner_picture_url" />
      </figure>

      <figure v-else class="applicator-card-banner placeholder">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.76 92.78">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Cerakote_Logos" data-name="Cerakote Logos">
              <g id="Cerakote_White_Gold" data-name="Cerakote White &amp; Gold">
                <rect id="Bar" class="logo-1" y="80.91" width="232.37" height="11.87" />
                <g id="Cerakote">
                  <path class="logo-2" d="M167.21,61a2,2,0,0,0,1.3-.54,1.93,1.93,0,0,0,.63-1.55v-48a2.12,2.12,0,0,0-.59-1.63,1.84,1.84,0,0,0-1.25-.55,2.13,2.13,0,0,0-1.34.55,2,2,0,0,0-.67,1.63v48a1.93,1.93,0,0,0,.63,1.55,2,2,0,0,0,1.29.54m3.72-61c3.44,0,6,.82,7.63,2.47S181,6.92,181,10.88v48c0,4.07-.73,6.91-2.21,8.5s-3.88,2.38-7.22,2.38h-8.17q-5.17,0-7.6-2.51t-2.42-8.37v-48c0-4.07.73-6.9,2.17-8.49S159.41,0,162.75,0Z" />
                  <path class="logo-2" d="M24.77,2.47C23.15.82,20.59,0,17.07,0H9.37q-5,0-7.19,2.39T0,10.88v48q0,5.86,2.43,8.37C4.05,69,6.58,69.8,10,69.8h7.79c3.35,0,5.74-.79,7.2-2.38S27.2,63,27.2,58.92V44.34H15.73V58.92a1.93,1.93,0,0,1-.62,1.55,1.83,1.83,0,0,1-2.6,0,1.93,1.93,0,0,1-.62-1.55v-48a2,2,0,0,1,.66-1.63,2.17,2.17,0,0,1,1.34-.55,1.84,1.84,0,0,1,1.26.55,2.12,2.12,0,0,1,.58,1.63V23H27.2V10.88q0-5.94-2.43-8.41" />
                  <path class="logo-2" d="M100.21,42.68l2.14-28.17,2.13,28.17h-4.27m6.27,26.37h11.38L111.36.92h-18L86.83,69.05H98.22l1.3-17.16h5.66Z" />
                  <polyline class="logo-2" points="211.53 0.92 211.53 69.05 232.37 69.05 232.37 59.86 223.41 59.86 223.41 38.99 231.54 38.99 231.54 29.8 223.41 29.8 223.41 10.11 232.37 10.11 232.37 0.92 211.53 0.92" />
                  <polyline class="logo-2" points="208.76 0.92 183.82 0.92 183.82 10.11 190.35 10.11 190.35 69.05 202.23 69.05 202.23 10.11 208.76 10.11 208.76 0.92" />
                  <polyline class="logo-2" points="152.01 69.05 143.15 33.92 149.14 0.92 137.58 0.92 132.52 30.15 132.52 0.92 120.64 0.92 120.64 69.05 132.52 69.05 132.52 36.94 139.76 69.05 152.01 69.05" />
                  <polyline class="logo-2" points="52.23 10.11 52.23 0.92 31.39 0.92 31.39 69.05 52.23 69.05 52.23 59.86 43.27 59.86 43.27 38.99 51.39 38.99 51.39 29.8 43.27 29.8 43.27 10.11 52.23 10.11" />
                  <path class="logo-2" d="M71.53,32.68a1.94,1.94,0,0,1-1.3.55H68.3V9.63h2a1.83,1.83,0,0,1,1.26.54,2.12,2.12,0,0,1,.59,1.63V31.13a1.93,1.93,0,0,1-.63,1.55m11,1.8c1-1.62,1.54-4.15,1.54-7.61V11.8q0-5.94-2.46-8.41T73.94.92H56.42V69.05H68.3V42.1h1.93a2,2,0,0,1,1.3.54,2,2,0,0,1,.63,1.55V69.05H84V47.81h0c0-3.2-.54-5.6-1.53-7.18a6.9,6.9,0,0,0-5-3.05,7.2,7.2,0,0,0,5-3.1" />
                  <path class="logo-2" d="M234.13,4.59c0-1.95.31-2.67.67-3s.68-.53,1.72-.53h1.85c1,0,1.39.2,1.72.53s.67,1.09.67,3-.31,2.68-.67,3-.68.53-1.72.53h-1.85c-1,0-1.39-.19-1.72-.53S234.13,6.53,234.13,4.59Zm1.23,2.58c.22.24.47.35,1.21.35h1.75c.74,0,1-.11,1.22-.35s.48-.82.48-2.58-.21-2.29-.48-2.58-.48-.34-1.22-.34h-1.75c-.74,0-1,.11-1.21.34s-.48.83-.48,2.58S235.08,6.89,235.36,7.17Zm2.51-1.89c-.05,0-.12-.06-.37-.06H237V6.53h-1.26V2.6h2.55a1.06,1.06,0,0,1,.77.2c.18.17.26.39.26.93,0,.72-.21,1-.68,1h0c.41.08.64.2.65.78,0,.38,0,.77.06,1h-1.27a5.12,5.12,0,0,1-.08-.85C238,5.38,237.93,5.33,237.87,5.28Zm-.25-.94c.23,0,.27,0,.33,0s.08-.14.08-.37,0-.29-.07-.35-.11-.06-.34-.06H237v.83Z" />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </figure>

      <a class="applicator-card-details" :href="pageURL" target="_blank" @click.prevent="$root.SelectApplicator(applicator)">

        <div class="applicator-card-details-header">

          <div class="applicator-card-details-name">

            <span
              v-for="(labelItem, index) in label"
              v-if="label"
              :key="index"
              :class="`applicator-card-label ${labelItem.class}`"
            >
              <i :class="`fa fa-${labelItem.icon}`"></i>
              {{ labelItem.name }}
            </span>

            <div class="applicator-card-details-rating">
              <i v-for="n in 5" :class="`fa ${n <= applicator.rating ? 'fa-star rated' : 'fa-star-o unrated'}`" :key="`rating-${applicator.user_id}-${n}`"></i>
              <span class="applicator-card-details-rating-count">{{ applicator.review_count }} Reviews</span>
            </div>

            <h3>{{ applicator.company_name }}</h3>

            <div class="applicator-card-details-location">
              <i class="fa fa-map-marker"></i>
              <span>{{ applicator.city ? applicator.city : '' }}</span>
              <span>{{ applicator.region ? `, ${applicator.region}` : '' }}</span>
            </div>

          </div>
        </div>

        <div v-if="applicator.business_types !== null && applicator.business_types.length > 0" class="applicator-card-info-panel">
          <strong>Business Type:</strong>
          <span>{{ applicator.business_types[0] }}</span>
        </div>

        <div v-if="workAcceptedPreview !== null && workAcceptedPreview.length > 0" class="applicator-card-info-panel">
          <strong>Work Accepted:</strong>
          <ul class="applicator-card-info-panel-pills">
            <li v-for="n in workAcceptedPreview.length">{{ applicator.work_accepted[n-1] }}</li>
            <li v-if="applicator.work_accepted.length > workAcceptedPreview.length">+ {{ applicator.work_accepted.length - workAcceptedPreview.length }} more</li>
          </ul>
        </div>

        <div v-if="certificationsPreview !== null && certificationsPreview.length > 0" class="applicator-card-info-panel">
          <strong>Production Capabilities:</strong>
          <ul class="applicator-card-info-panel-pills">
            <li v-for="certification in certificationsPreview">{{ certification }}</li>
            <li v-if="certifications.length > certificationsPreview.length">+ {{ certifications.length - certificationsPreview.length }} more</li>
          </ul>
        </div>

      </a>

    </div>

    <div class="applicator-card-actions">
      <a v-if="applicator.company_phone" class="btn btn-alt-outline" @click="dataLayer.push({'applicatorId': `${applicator.customer_id}`, 'event': 'applicatorPhone'})" :href="PhoneLink(applicator.company_phone)">
        <i class="fa fa-phone"></i>
        <span>Call</span>
      </a>
      <button type="button" class="btn btn-alt-outline" @click.prevent="$root.SelectApplicator(applicator)">
        <span>More Details</span>
        <i class="fa fa-long-arrow-right"></i>
      </button>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'applicator-card',
  }
</script>

<style lang="scss">
  .applicator-card {
    transition: box-shadow 200ms ease-in-out, transform 200ms ease-in-out;
    border-radius: var(--applicator-border-radius);
    box-shadow: 0 1px 2px 0 rgba(black, 0.15);
    margin-bottom: var(--sidebar-padding);
    transform: translate3d(0, 0, 0);
    background-color: #ffffff;
    align-items: flex-start;
    flex-direction: column;
    position: relative;
    flex-wrap: nowrap;
    display: flex;

    &[aria-disabled] {
      pointer-events: none;
      user-select: none;
      -moz-user-focus: none;
    }

    &-loading {
      background-color: rgba(white, 0.85);
      justify-content: center;
      border-radius: inherit;
      align-items: center;
      position: absolute;
      overflow: hidden;
      display: flex;
      z-index: 1;
      bottom: 0;
      right: 0;
      left: 0;
      top: 0;
    }

    &.distributor {
      border-style: solid;
      border-width: 3px;
      border-color: #F78F1B;
      background-color: #ffb5001A;
    }

    &:hover,
    &:focus-within {
      box-shadow: 0 10px 20px rgba(black, 0.19), 0 6px 6px rgba(black, 0.23);
      transform: translate3d(0, -10px, 0);
      z-index: 2;
    }

    &-close {
      transition: box-shadow 200ms ease-in-out, color 200ms ease-in-out;
      box-shadow: 0 1px 2px 0 rgba(black, 0.15);
      transform: translate3d(50%, -50%, 0);
      justify-content: center;
      background-color: white;
      align-items: center;
      position: absolute;
      border-radius: 50%;
      font-size: 30px;
      color: #222222;
      line-height: 1;
      outline: none;
      display: flex;
      height: 36px;
      width: 36px;
      z-index: 2;
      padding: 0;
      border: 0;
      right: 0;
      top: 0;

      &:hover,
      &:focus-within {
        box-shadow: 0 10px 20px rgba(black, 0.19), 0 6px 6px rgba(black, 0.23);
        color: #f69422;
      }
    }

    &-label {
      border-radius: var(--applicator-border-radius);
      display: inline-flex;
      align-items: center;
      margin-bottom: 4px;
      font-weight: 600;
      padding: 4px 6px;
      font-size: 12px;
      margin-right: 4px;
      color: white;

      &.certified {
        background-color: #333;
      }

      &.distributor {
        background-color: #3E6B85;
      }

      &.customers-choice {
        background-color: #f69422;
      }

      &.comingSoon {
        background-color: #0ba10b;
      }

      > .fa {
        margin-right: 4px;
        font-size: 16px;
      }
    }

    &-showcase {
      flex-direction: column;
      margin-bottom: 16px;
      display: flex;
      width: 35%;

      @media screen and (max-width: 1024px) {
        width: 100%;
      }

      &-slider {
        border-radius: var(--applicator-border-radius);
        background-color: #dadada;
        justify-content: center;
        padding-bottom: 100%;
        position: relative;
        overflow: hidden;
        display: flex;
        width: 100%;

        @media screen and (max-width: 1024px) {
          border-bottom-right-radius: 0;
          border-bottom-left-radius: 0;
          margin: -16px -16px 0;
          padding-bottom: 80%;
          width: auto;
        }
      }

      &-projects {
        transition: transform 200ms ease-in-out;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
        position: absolute;
        flex-wrap: nowrap;
        min-width: 100%;
        display: flex;
        height: 100%;
        width: auto;
        left: 0;
        top: 0;

        &[data-active='0'] {
          transform: translate3d(0, 0, 0);
        }

        &[data-active='1'] {
          transform: translate3d(-100%, 0, 0);
        }

        &[data-active='2'] {
          transform: translate3d(-200%, 0, 0);
        }

        &[data-active='3'] {
          transform: translate3d(-300%, 0, 0);
        }

        &[data-active='4'] {
          transform: translate3d(-400%, 0, 0);
        }

        > img {
          max-width: 100%;
          flex: 1 0 100%;
          display: block;
          height: auto;
          width: 100%;
        }
      }

      &-nav {
        margin-top: 6px;
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 6px;
        width: 100%;

        > button {
          border-radius: var(--applicator-border-radius);
          border: 2px solid #e6e6e6;
          background-color: transparent;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          display: flex;
          padding: 2px;
          flex: 1;

          > img {
            border-radius: inherit;
            display: block;
            width: 100%;
          }

          &[aria-selected] {
            border-color: #f69422;
          }

          &:hover,
          &:focus {
            outline: none;
          }
        }
      }
    }

    &-banner {
      border-radius: var(--applicator-border-radius);
      background-color: #dadada;
      justify-content: center;
      padding-bottom: 35%;
      position: relative;
      overflow: hidden;
      display: flex;
      width: 35%;
      z-index: 1;
      height: 0;

      @media screen and (max-width: 1024px) {
        padding-bottom: calc(56.25% + 32px);
        margin: -16px -16px 16px -16px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        width: auto;
      }

      > img {
        position: absolute;
        min-width: 100%;
        display: block;
        height: 100%;
        width: auto;
        top: 0;
      }

      &.placeholder {
        > svg {
          transform: translate3d(-50%, -50%, 0);
          position: absolute;
          opacity: 0.25;
          width: 50%;
          left: 50%;
          top: 50%;

          .logo-1,
          .logo-2 {
            fill: #3a3a39;
          }
        }
      }
    }

    &-content {
      flex-direction: row;
      padding: 16px;
      display: flex;
      width: 100%;

      @media screen and (max-width: 1024px) {
        flex-direction: column;
      }
    }

    &-info-panel {
      flex-direction: column;
      word-wrap: break-word;
      max-width: 100%;
      font-size: 14px;
      display: flex;

      &-undefined {
        color: #a8a8a8;
      }

      &-pills,
      &-links {
        flex-direction: row;
        list-style: none;
        flex-wrap: wrap;
        margin-top: 4px;
        padding-left: 0px;
        display: flex;
        width: 100%;
      }

      &-pills {
        > li {
          border-radius: var(--applicator-border-radius);
          background-color: #efefef;
          margin: 0 4px 4px 0;
          font-weight: 600;
          padding: 4px 6px;
          font-size: 12px;
        }
      }

      &-links {
        > li {
          + li::before {
            content: ',';
            margin: 0 4px 0 1px;
            color: #222222;
          }
        }
      }

      + .applicator-card-info-panel {
        margin-top: 8px;
      }
    }

    &-details {
      flex-direction: column;
      padding-left: 16px;
      color: #222222;
      display: flex;
      width: 100%;
      flex: 1;

      &:hover,
      &:focus-within {
        color: #222222 !important;

        h3 {
          color: #f69422;
        }
      }

      @media screen and (max-width: 1024px) {
        padding-left: 0;
      }

      &-header {
        align-items: flex-start;
        padding-bottom: 16px;
        flex-direction: row;
        display: flex;
      }

      &-avatar {
        background-color: white;
        border-radius: 50%;
        margin-right: 10px;
        overflow: hidden;
        height: 72px;
        width: 72px;
        z-index: 1;

        @media screen and (max-width: 1024px) {
          height: 60px;
          width: 60px;
        }
      }

      &-name {
        flex: 1;

        h3 {
          transition: color 200ms ease-in-out;
          line-height: 1.365;
          font-weight: 600;
          font-size: 19px;
          color: #222222;
          margin: 0;
        }
      }

      &-location {
        align-items: center;
        flex-direction: row;
        font-size: 14px;
        color: #222222;
        line-height: 1;
        margin: 4px 0;
        display: flex;

        > .fa {
          margin-right: 4px;
          font-size: 18px;
        }
      }

      &-rating {
        flex-direction: row;
        align-items: center;
        margin: 4px 0;
        display: flex;

        .fa {
          margin-right: 2px;
          color: #d8d8d8;
          font-size: 18px;

          &.rated {
            color: #f69422;
          }
        }

        &-count {
          margin-left: 6px;
          font-weight: 600;
          color: #8f8f8f;
          font-size: 12px;
        }
      }
    }

    &-actions {
      padding: 0 16px 16px;
      flex-direction: row;
      flex-wrap: nowrap;
      display: flex;
      width: 100%;

      .btn {
        flex: 1;

        + .btn {
          margin-left: 10px;
          margin-top: 0;
        }
      }

      @media screen and (max-width: 1024px) {
        flex-direction: column;

        .btn {
          flex: auto;

          + .btn {
            margin-left: 0;
            margin-top: 10px;
          }
        }
      }
    }
  }
</style>

<script>
  import ImageMixin from '../../mixins/images';
  import URLMixin from '../../mixins/url';
  import Computed from '../../mixins/applicator-map-utils';

  export default {
    name: 'applicator-card',

    props: {
      applicator: Object,
      closeButton: { type: Boolean, default: false },
    },

    mixins: [ImageMixin, URLMixin, Computed],

    data: () => {
      return {
        activeShowcaseProject: 0,
      };
    },

    // computed: {
      
    // },

    methods: {
      CloseApplicator() {
        this.$emit('close-applicator');
      },

      SetActiveShowcaseProject(key) {
        this.activeShowcaseProject = key;
      }
    },
  };
</script>
